// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OY2a","newExpiryDate":"styles_newExpiryDate__3xc9U","footer":"styles_footer__30FDU"};